module.exports = __webpack_public_path__ + "Roboto-MediumItalic.da059a7386fea889c55c.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-MediumItalic.woff
// module chunks = 16